import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navLinks, site } from "@/mocks/site";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden bg-primary-950 text-background-100 md:block">
        <div className="mx-auto flex h-9 max-w-content items-center justify-between px-4 md:px-6">
          <p className="flex items-center gap-2 text-xs tracking-wide text-background-200">
            <span className="inline-flex h-4 w-4 items-center justify-center">
              <i className="ri-fire-fill text-primary-400" />
            </span>
            {site.slogan}
          </p>
          <p className="flex items-center gap-4 text-xs text-background-300">
            <span>每日更新 · 前排围观</span>
            <a
              href={`mailto:${site.email}`}
              rel="nofollow"
              className="transition-colors hover:text-accent-400"
            >
              {site.email}
            </a>
          </p>
        </div>
      </div>

      <div
        className={`w-full border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-300/70 bg-background-50/95 backdrop-blur"
            : "border-transparent bg-background-50"
        }`}
      >
        <div className="mx-auto flex h-16 max-w-content items-center justify-between gap-4 px-4 md:px-6">
          <Link to="/" className="flex shrink-0 items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-emotion-laugh-line text-xl" />
            </span>
            <span className="leading-tight">
              <span className="block font-heading text-lg font-bold tracking-wide text-foreground-950">
                {site.brand}
              </span>
              <span className="hidden text-[11px] tracking-[0.22em] text-foreground-500 sm:block">
                {site.brandEn.toUpperCase()}
              </span>
            </span>
          </Link>

          <nav aria-label="主导航" className="hidden items-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-200/70 hover:text-foreground-950"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <Link
              to="/#newsletter"
              className="whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-foreground-800"
            >
              订阅吃瓜情报
            </Link>
          </div>

          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-200 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-b border-background-300 bg-background-50 lg:hidden">
          <nav aria-label="移动端导航" className="mx-auto max-w-content px-4 py-3">
            <ul className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="block rounded-md px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li className="pt-1">
                <Link
                  to="/#newsletter"
                  className="block rounded-md bg-foreground-950 px-3 py-2.5 text-center text-sm text-background-50"
                >
                  订阅吃瓜情报
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </header>
  );
}